import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const GpsTaikiJotaiKbn = props => {
  return <Dropdown.Static kubunKey='gps_taiki_jotai_kbn' {...props} />
}
